import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  /**
   * Returns all version sets for the given project.
   */
  getAll(projectUid) {
    return raw.getAll(routes.versionSets.all(projectUid));
  },
  /**
   * Create a version set.
   */
  createOne(projectUid, toCreate) {
    return raw.post(routes.versionSets.all(projectUid), toCreate);
  },
};
